import { useTranslation } from 'react-i18next';
import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';

const MapSection = ({ hotels }) => {

    const { t } = useTranslation();

    const [mapMarkers, setMapMarkers] = useState([]);
    const [center, setCenter] = useState([0, 0]); // Barcelona por defecto
    const [loading, setLoading] = useState(true);
    const [bounds, setBounds] = useState(null);

    useEffect(() => {
        if (hotels && hotels.length > 0) {
            setLoading(true);

            // Calcular centro
            const latSum = hotels.reduce((sum, hotel) => sum + Number(hotel.lat), 0);
            const lngSum = hotels.reduce((sum, hotel) => sum + Number(hotel.lng), 0);
            const centerLat = latSum / hotels.length;
            const centerLng = lngSum / hotels.length;
            setCenter([centerLat, centerLng]);

            // Calcular bounds
            const newBounds = hotels.reduce((bounds, hotel) => {
                return bounds.extend([Number(hotel.lat), Number(hotel.lng)]);
            }, L.latLngBounds([]));
            setBounds(newBounds);

            // Crear markers
            const markers = hotels.map((hotel, index) => (
                <Marker key={hotel.id} position={[Number(hotel.lat), Number(hotel.lng)]}>
                    <Popup>
                        <h3
                            style={{
                                marginBottom: "18px",
                                fontWeight: "800",
                                fontSize: "1.17em",
                                marginTop: "7px",
                                textTransform: "uppercase",
                                textAlign: "center",
                                cursor: "pointer"
                            }}
                        >
                            {hotel.name}
                        </h3>
                    </Popup>
                </Marker>
            ));

            setMapMarkers(markers);
            setLoading(false);
        }
        else {
            setLoading(true);
            const markers = (
                <Marker key="1" position={[41.3927673, 2.057617]}>
                    <Popup>
                        <h3
                            style={{
                                marginBottom: "18px",
                                fontWeight: "800",
                                fontSize: "1.17em",
                                marginTop: "7px",
                                textTransform: "uppercase",
                                textAlign: "center",
                                cursor: "pointer"
                            }}
                        >
                        </h3>
                    </Popup>
                </Marker>
            );
            const newBounds = ([41.3927673, 2.057617], L.latLngBounds([]));
            setBounds(newBounds);
            setCenter([41.3927673, 2.057617]);
            setMapMarkers(markers);
            setLoading(false);

        }
    }, [hotels]);

    // Componente para ajustar bounds
    const FitBounds = ({ bounds }) => {
        const map = useMap();
        useEffect(() => {
            if (bounds && bounds.isValid()) {
                map.fitBounds(bounds, { padding: [20, 20] });
            }
        }, [map, bounds]);
        return null;
    };

    return (

        <div id="js-hide-landing" className="cc-header-img mt-header height-fixed">
            <div className="c-header-img">
                <app-map height="408px">
                    <div id="map" style={{ height: "408px", overflow: "hidden" }}>
                        {(!loading) ? (
                            <MapContainer
                                center={center}
                                scrollWheelZoom={false}
                                zoom={13}
                                style={{ height: "408px", width: "100%", maxWidth: "100vw", overflow: "hidden", margin: "0", borderRadius: "0", zIndex: "1" }}
                            >
                                <TileLayer
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                                {mapMarkers}
                                {bounds & <FitBounds bounds={bounds} />}
                            </MapContainer>
                        ) : (
                            <div
                                style={{
                                    height: "100%",
                                    width: "100%",
                                    backgroundColor: "#f8f9fa",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "8px"
                                }}
                            >
                                <div className="text-center text-muted">
                                    <div className="mb-2 spinner-border spinner-border-sm" role="status"></div>
                                    <small>{t("Cargando mapa...")}</small>
                                </div>
                            </div>
                        )}
                    </div>
                </app-map>
                <h1 id="seach-container">{t("Encuentra tu apartamento")}</h1>

            </div>
        </div>
    );
}

export default MapSection;
